module.exports = __webpack_public_path__ + "img/PantallaPromo-01.754d1192.svg";